import { ICreatePesquisaSatisfacaoUseCase } from "../../../presentation/useCases/create/create_pesquisa_satisfacao_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * CreatePesquisaSatisfacaoUseCase
 */

export class CreatePesquisaSatisfacaoUseCase implements ICreatePesquisaSatisfacaoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async createPesquisaSatisfacao(
    status: number,
    codigo: string,
    descricao: string,
  ): Promise<void> {
    await this.repository.createPesquisaSatisfacao(
      status,
      codigo,
      descricao,
    );
  }
}
